module.exports = __webpack_public_path__ + "media/images/city/021-tower-bridge-d224d740bf6647fb09ccfb9a26b07f83.svg";